import axiosConfig from "./axiosConfig";

const pushApi = {};

pushApi.saveSubscription = (subscription) =>
  axiosConfig.post("/api/push-subscriptions/", subscription);
pushApi.deleteSubscription = (endpoint) =>
  axiosConfig.delete("/api/push-subscriptions/", { data: { endpoint } });

export default pushApi;
